const initialState = {
  id: null,
  data: [],
  isLoading: false,
  error: null,
  total: 0,
  page: 0,
  limit: 10,
};

export default initialState;
